export const styles = {
  root: (theme) => ({
    overflow: 'hidden',
    position: 'relative',
    boxSizing: 'border-box',
    display: 'inline-block',
    width: 424,
    height: 301,
    borderRadius: 4,
    padding: 3,
    '&:not(:last-child)': {
      mr: 4,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxWidth: 423,
      height: 259,
      minWidth: 314,
      padding: theme.spacing(3, 2),
      '&:not(:last-child)': {
        mb: 2,
      },
    },
    boxShadow:
      '-2px -2px 7px rgba(227, 225, 237, 0.68), 1px 1px 10px rgba(223, 221, 231, 0.76);',
  }),
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 2,
  },
  name: (theme) => ({
    fontSize: 24,
    fontWeight: 700,
    letterSpacing: '-0.06em',
    [theme.breakpoints.down('lg')]: {
      fontSize: 22,
    },
  }),
  lengths: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    my: 0,
  },
  length: {
    display: 'flex',
    alignItems: 'center',
    mr: 2,
  },
  link: {
    display: 'inline-block',
    textDecoration: 'none',
  },
  chip: {
    fontSize: 12,
    padding: '8px 4px',
    height: 22,
    borderRadius: 1,
  },
};
